// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tw-benchmark-header[data-v-501e641f]{margin-bottom:16px}", "",{"version":3,"sources":["webpack://./src/client/features/twitter_benchmark_analytics/components/tw_benchmark_header/TwBenchmarkHeader.vue"],"names":[],"mappings":"AACA,sCACE,kBAAA","sourcesContent":["\n.tw-benchmark-header {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
